var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProxies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.5H18.75C19.9926 4.5 21 5.50736 21 6.75C21 7.99264 19.9926 9 18.75 9H3.75C2.50736 9 1.5 7.99264 1.5 6.75C1.5 5.50736 2.50736 4.5 3.75 4.5ZM0 6.75C0 4.67893 1.67893 3 3.75 3H18.75C20.8211 3 22.5 4.67893 22.5 6.75C22.5 8.82107 20.8211 10.5 18.75 10.5H12V13.575C13.4693 13.8733 14.6267 15.0307 14.925 16.5H21.75C22.1642 16.5 22.5 16.8358 22.5 17.25C22.5 17.6642 22.1642 18 21.75 18H14.925C14.5775 19.7117 13.0642 21 11.25 21C9.43578 21 7.92247 19.7117 7.57501 18H0.75C0.335786 18 0 17.6642 0 17.25C0 16.8358 0.335786 16.5 0.75 16.5H7.57501C7.87328 15.0307 9.03065 13.8733 10.5 13.575V10.5H3.75C1.67893 10.5 0 8.82107 0 6.75ZM11.25 15C12.4926 15 13.5 16.0074 13.5 17.25C13.5 18.4926 12.4926 19.5 11.25 19.5C10.0074 19.5 9 18.4926 9 17.25C9 16.0074 10.0074 15 11.25 15ZM3 6.75C3 6.33579 3.33579 6 3.75 6C4.16421 6 4.5 6.33579 4.5 6.75C4.5 7.16421 4.16421 7.5 3.75 7.5C3.33579 7.5 3 7.16421 3 6.75ZM6.75 6C6.33579 6 6 6.33579 6 6.75C6 7.16421 6.33579 7.5 6.75 7.5C7.16421 7.5 7.5 7.16421 7.5 6.75C7.5 6.33579 7.16421 6 6.75 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxies);
export default __webpack_public_path__ + "static/media/proxies.4bc14b8d3f3358fcf640a6fff56af2a0.svg";
export { ForwardRef as ReactComponent };